import React from 'react';
import { Button } from '@duxton-web/ui';
import scribe from '@grab-x/scribe-web-sdk';
import { useParams } from 'react-router-dom';

import PercentageSplitValues from './percentage-split-values';
import { newCreationFlowEvents } from '@/common/Scribe/EventsList';
import {
  ExperimentAssignmentStrategy,
  getAssignmentStrategy,
  isPercentageSplitStrategy,
  isViewMode,
} from '@/features/experiment/constants';
import {
  useExperimentContext,
  useExperimentDispatchContext,
} from '@/features/experiment/contexts/experiment-context';
import { splitTreatmentsEvenly } from '@/features/experiment/store/actions/experiment/action-creators';

const PercentageSplit = () => {
  const params = useParams<{ experimentName: string; action: string }>();
  const { action } = params;
  const readOnly = isViewMode(action);

  const experimentContext = useExperimentContext();
  const { experiment, configurations } = experimentContext;
  const experimentDispatch = useExperimentDispatchContext();
  const experimentStrategy = getAssignmentStrategy(configurations);

  if (!isPercentageSplitStrategy(experimentStrategy)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {!readOnly && (
        <Button
          style={{
            alignSelf: 'flex-end',
          }}
          size="small"
          onClick={() => {
            scribe.sendEvent(newCreationFlowEvents.clickSplitEvenly.name, {
              experiment_name: experiment?.name,
              STATE_NAME: newCreationFlowEvents.clickSplitEvenly.state,
            });
            experimentDispatch(splitTreatmentsEvenly());
          }}
          disabled={
            experimentStrategy === ExperimentAssignmentStrategy.UNIFORM_CHOICE
          }
        >
          Split Evenly
        </Button>
      )}
      <PercentageSplitValues />
    </div>
  );
};

export default PercentageSplit;
